import React from 'react';
import PropTypes from 'prop-types';

import Img from '../../Img';
import { CARD_BRAND_ICON_MAP } from './constants';

import styles from './sidebarPowerCheckout.scss';

const CardOnFileSection = ({ paymentSource, isLoading }) => {
    const cardType = paymentSource?.type ?? '';
    const last4 = paymentSource?.last4 ?? '';
    const cardholderName = paymentSource?.cardholderName ?? '';
    const dots = cardType.toLowerCase() === 'american express' ? '**** ****** *' : '**** **** **** ';

    if (isLoading) {
        return (
            <>
                <div className={styles.cardPlaceholderName} />
                <div className={styles.cardPlaceholderNumber} />
                <div className={styles.cardPlaceholderBrand} />
            </>
        );
    }

    return (
        <>
            {cardholderName && (
                <div className={styles.cardholderName}>{cardholderName}</div>
            )}
            {last4 && (
                <div className={styles.maskedNumber}>{dots}{last4}</div>
            )}
            {cardType && CARD_BRAND_ICON_MAP[cardType.toLowerCase()] && (
                <Img
                    className={styles.cardBrandIcon}
                    src={CARD_BRAND_ICON_MAP[cardType.toLowerCase()]}
                />
            )}
        </>
    );
};

CardOnFileSection.propTypes = {
    paymentSource: PropTypes.shape({
        type: PropTypes.string,
        last4: PropTypes.string,
        cardholderName: PropTypes.string,
    }),
    isLoading: PropTypes.bool,
};

CardOnFileSection.defaultProps = {
    paymentSource: null,
    isLoading: false,
};

export default CardOnFileSection;
